module.exports = __webpack_public_path__ + "img/participants-event-join-icon.b135e807.svg";